import { NUMBER_CONVERTED_KG_TO_POUNDS } from 'common/constants'

export const convertToPound = (weight: number) => {
  return Math.round(weight * NUMBER_CONVERTED_KG_TO_POUNDS)
}
